import AccountsTableDetailsRecord from "./model/accountsTableDetailsRecord.js";
import TerritoryModelDetails from "./model/territoryModelDetails.js";
import TerritoryModelMetadata from "./model/territoryModelMetadata.js";

export default class FeedbackLocalDataService {
  _territoryModelDetails;
  _territoryModelMetadata;

  constructor(accountsTableDetails) {
    this._territoryModelDetails =
      accountsTableDetails instanceof AccountsTableDetailsRecord
        ? new TerritoryModelDetails(accountsTableDetails)
        : null;
    this._territoryModelMetadata =
      accountsTableDetails instanceof AccountsTableDetailsRecord
        ? new TerritoryModelMetadata(accountsTableDetails)
        : null;
  }

  get territoryModelDetails() {
    return this._territoryModelDetails;
  }

  get territoryModelMetadata() {
    return this._territoryModelMetadata;
  }
}
